import { forwardRef, PropsWithChildren, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Add } from '@mui/icons-material';
import { Box, Button } from '@mui/material';

import { openAddIngredientModal } from '@store/features/adminInquiries/ingredientsSearch/slice';

import styles from './index.module.scss';

interface IProps extends PropsWithChildren {
  onButtonClick?: () => void;
}

const ListboxWithCustomFooter = forwardRef((props: IProps, ref: any) => {
  const { children, onButtonClick, ...rest } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleAddOption = useCallback(() => {
    dispatch(openAddIngredientModal());
  }, []);

  return (
    <>
      <Box ref={ref} {...rest} component="ul">
        {children}
      </Box>
      <Box className={styles.footer}>
        <Button
          size="small"
          fullWidth
          variant="text"
          className={styles.button}
          onMouseDown={event => event.preventDefault()}
          onClick={handleAddOption}
        >
          <Add className={styles.icon} />
          {t('admin.newIngredient')}
        </Button>
      </Box>
    </>
  );
});

export default ListboxWithCustomFooter;
